import requestApi from '@/utils/requestApi';

async function sendEmailAuth(email) {
  var videoID = process.env.VUE_APP_VIDEO_ID;
  try {
    await requestApi({
      url: `/v2/videobot/vivo/tfa`,
      method: 'post',
      data: {
        videobot_data: {
            video_id: videoID,
            email: email
        }
      }
    });

    return true;
  } catch (error) {
    return false;
  }
}

async function sendCodAuth(cod){
  var videoID = process.env.VUE_APP_VIDEO_ID;
  try {
    const response = await requestApi({
      url: `/v2/videobot/vivo/video/${videoID}/tfa/${cod}`,
      method: 'get',
    });
    localStorage.setItem('TOKEN_VIDEOBOT', response.data.token);
    this.TOKEN_VIDEOBOT = response.data.token
    return true;
  } catch (error) {
    return false;
  }
}

function seekToAfter(timeToGo, timeToWait) {
  return window.felixBag?.setTimeout(function () {
    window.felixBag?.trigger(window.Ovm?.JB.Cmd.SEEK_TO, timeToGo);
  }, timeToWait);
}

function playVideo() {
  window.felixBag?.trigger(window.Ovm?.JB.Cmd.PLAY);
}

function pauseVideo() {
  window.felixBag?.trigger(window.Ovm?.JB.Cmd.PAUSE);
}

function seekTo(time) {
  window.felixBag?.trigger(window.Ovm?.JB.Cmd.SEEK_TO, time);
}

function seekToNoHide(time) {
  window.felixBag?.trigger(window.Ovm?.JB.Cmd.SEEK_TO, {
    time: time,
    hideAll: false,
  });
}

function pauseAfter(secs) {
  if (!secs && secs === 0) return false;

  return window.felixBag?.setTimeout(function () {
    pauseVideo();
  }, secs);
}

function saveEvent(source, action, value, message) {
  window.felixBag?.trigger(window.Ovm?.JB.Cmd.TRACK_EVENT, {
    name: 'user_interacted',
    source: source,
    action: action,
    value: value,
    message: message,
  });
}

function showInteractive(name) {
  window.felixBag?.trigger(window.Ovm?.JB.Cmd.SHOW_INTERACTIVE, name);
}

function hideInteractive(name) {
  window.felixBag?.trigger(window.Ovm?.JB.Cmd.HIDE_INTERACTIVE, name);
}

function rewriteOnDocument() {
  // window.felixBag.callbacks.onDocumentHidden = () => { window.felixBag?.trigger(window.Ovm?.JB.Cmd.PAUSE) };
  // window.felixBag.callbacks.onDocumentVisible = () => {
  //   if (felixBag.activeInteractives().length > 1) {
  //     window.felixBag?.trigger(window.Ovm?.JB.Cmd.PLAY)
  //   }
  // };
}

function muteVideo() {
  window.felixBag.trigger(window.Ovm.JB.Cmd.MUTE);
  window.felixBag.statusSom = false;
}

function unmuteVideo() {
  window.felixBag.trigger(window.Ovm.JB.Cmd.UNMUTE);
  window.felixBag.statusSom = true;
}

export const actions = {
  seekToAfter,
  playVideo,
  pauseVideo,
  seekTo,
  seekToNoHide,
  pauseAfter,
  saveEvent,
  showInteractive,
  hideInteractive,
  rewriteOnDocument,
  muteVideo,
  unmuteVideo,
  sendEmailAuth,
  sendCodAuth
};
